import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorRamSpeed,
  fetchProcessorRamSpeed,
  fetchProcessorRamSpeedById,
  updateProcessorRamSpeed,
  updateStatusInProcessorRamSpeed,
} from "./thunk";

interface CategoryState {
  processor_ram_speed_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_ram_speed_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "ram_speed",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorRamSpeed.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorRamSpeed.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_ram_speed_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorRamSpeed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Processor Threads";
      })
      .addCase(fetchProcessorRamSpeedById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorRamSpeedById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorRamSpeedById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorRamSpeed.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ram_speed_list = state.processor_ram_speed_list.map((ram_capacity) =>
          ram_capacity.id === action.payload.id ? action.payload : ram_capacity
        );
      })
      .addCase(addProcessorRamSpeed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorRamSpeed.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ram_speed_list = state.processor_ram_speed_list.map((ram_capacity) =>
          ram_capacity.id === action.payload.id ? action.payload : ram_capacity
        );
      })
      .addCase(updateProcessorRamSpeed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorRamSpeed.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorRamSpeed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
